import isEmpty from 'lodash/isEmpty';
import isNul from 'lodash/isNil';
import isObject from 'lodash/isObject';
import FieldTypes from '../../connect-card/constants/field-types';
import { formatAddress, getChildrenNames } from '../utils';

const hasValue = (value) => !isEmpty(value) || !isNul(value);

const getStringValue = (type, value) => {
  switch (type) {
    case FieldTypes.NAME: {
      return value && `${value.firstName} ${value.lastName || ''}`.trim();
    }
    case FieldTypes.SCHEDULER: {
      if (value?.datetime) {
        return value.datetime;
      }
      return undefined;
    }
    case FieldTypes.ADD_MEMBERS: {
      return value && getChildrenNames(value);
    }
    case FieldTypes.ADDRESS: {
      return value && formatAddress(value);
    }
    case FieldTypes.CHOICE: {
      if (value) {
        if (Array.isArray(value)) {
          return value.map((val) => val.label).join(', ');
        }
        return value.label;
      }
      return null;
    }
    case FieldTypes.BOOLEAN: {
      return value ? 'Yes' : 'No';
    }
    default:
      return value;
  }
};

export const getFieldValue = (question, field) => {
  let value;
  if (field.name !== undefined) {
    value = hasValue(field.value) ? field.value : undefined;
  } else if (isObject(field)) {
    const child = {};
    Object.keys(field).forEach((childKey) => {
      child[childKey] = field[childKey].value;
    });
    value = isEmpty(child) ? undefined : child;
  }
  const valString = getStringValue(question.question_type, value);
  return {
    value,
    valueString: valString,
  };
};

export const getFormValues = (form, questions) => {
  const questionMap = questions.reduce((acc, question) => {
    acc[question.hash] = question;
    return acc;
  }, {});

  return Object.keys(form).map((key) => {
    const field = form[key];
    const question = questionMap[key];
    const { value, valueString } = getFieldValue(question, field);
    question.valueString = valueString;
    question.value = value;
    return question;
  });
};
